module.exports = __webpack_public_path__ + "static/about-photo-triangle-f6f5236788fe1e0b79a3b5b628ce92e1.png";